import { GiftCardRedemptionScreen } from '../../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <GiftCardRedemptionScreen />;
}
